import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const FIELD_LABELS = {
  rendah_max: "Batas maks. skor Rendah",
  sedang_max: "Batas maks. skor Sedang",
  tinggi_max: "Batas maks. skor Tinggi (di atasnya = Kritis)",
  investigasi_internal_min: "Skor min. investigasi internal",
  investigasi_eksternal_min: "Skor min. investigasi eksternal",
};

const ThresholdCard = ({ threshold, onSaved }) => {
  const [form, setForm] = useState(threshold);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const body = Object.fromEntries(Object.keys(FIELD_LABELS).map((k) => [k, Number(form[k])]));
      await api.put(`/admin/thresholds/${threshold.claim_type}`, body);
      toast.success(`Threshold ${threshold.claim_type} tersimpan`);
      onSaved();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="bg-card border border-border p-5 space-y-4" data-testid={`threshold-card-${threshold.claim_type}`}>
      <h3 className="text-sm font-semibold capitalize">Asuransi {threshold.claim_type}</h3>
      {Object.entries(FIELD_LABELS).map(([k, label]) => (
        <div key={k} className="flex items-center justify-between gap-4">
          <Label className="text-xs text-muted-foreground">{label}</Label>
          <Input data-testid={`threshold-${threshold.claim_type}-${k}`} type="number" min="1" max="100" className="w-24 h-8"
            value={form[k]} onChange={(e) => setForm((s) => ({ ...s, [k]: e.target.value }))} />
        </div>
      ))}
      <Button data-testid={`threshold-save-${threshold.claim_type}`} onClick={save} disabled={saving}
        className="w-full bg-slate-900 hover:bg-slate-800 rounded-none">Simpan</Button>
    </div>
  );
};

export default function ThresholdsTab() {
  const [thresholds, setThresholds] = useState([]);
  const load = () => api.get("/admin/thresholds").then((r) => setThresholds(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
      {thresholds.map((t) => <ThresholdCard key={t.claim_type} threshold={t} onSaved={load} />)}
    </div>
  );
}
